import ENV_VARS from '@/config'
import { get, post, del, put } from '@/ports/api'
const { BACKEND_SERVER } = ENV_VARS

export const sendFile = post(`${BACKEND_SERVER}/secure/%portTag%`)
export const deleteFile = del(`${BACKEND_SERVER}/secure/%tag%/%fileId%`)
export const updateCreditCheck = put(`${BACKEND_SERVER}/users/me`)
export const requestCreditCheck = post(`${BACKEND_SERVER}/users/credit_check`, {
  failSilently: true
})
export const submitCreditReportData = post(
  `${BACKEND_SERVER}/trust_score/submit_credit_report_data`
)
export const checkCancelSubmissionAvailability = get(
  `${BACKEND_SERVER}/trust_score/check_cancel_submission_availability`
)
export const cancelCreditReportSubmission = post(
  `${BACKEND_SERVER}/trust_score/cancel_credit_report_submission`
)
export const checkCreditReportStatus = get(`${BACKEND_SERVER}/trust_score/check_my_status`)

export const doNotShowAgainFlag = get(`${BACKEND_SERVER}/flags/users/trust_score_modal`, {
  failSilently: true
})
